module.exports = __webpack_public_path__ + "img/styleBlack.bfb9fad7.svg";